<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Instructor</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama Instruktur</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Masukkan Nama Lengkap Instruktur"
                v-model="form.name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Pekerjaan / Jabatan</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Masukkan Bidang Pekerjaan / Jabatan Terkini"
                v-model="form.position"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Asal Instansi / Perusahaan</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Masukkan Nama Instansi / Perusahaan"
                v-model="form.company"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Biografi</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Tulis di sini...."
                outlined
                rows="3"
                v-model="form.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>CV URL</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Masukkan URL CV Anda"
                v-model="form.cv_url"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>LinkedIn URL</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Masukkan LinkedIn URL Anda"
                v-model="form.linkedin_url"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Foto Profil</p>
              <v-file-input
                v-model="img_web"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template v-slot:prepend-inner v-if="isEdit && img_web == null">
                  <ImageModal
                    :src="form.image_url"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                *Rekomendasi dimensi 500 x 500 px. ukuran file maks 1 MB
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Instructor Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Enter Instructor Full Name"
                v-model="formEng.name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Position / Job Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Enter Current Position or Job Title"
                v-model="formEng.position"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Company / Institution</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                class="form-input"
                placeholder="Enter Name of Company or Institution"
                v-model="formEng.company"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Biography</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Write here..."
                outlined
                rows="3"
                v-model="formEng.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/instructor')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import ImageModal from "@/components/ImageModal.vue";
import Arrow from "@/components/icons/Arrow.vue";

export default {
  name: "FormInstructor",
  components: {
    Loading,
    Button,
    Popup,
    ImageModal,
    Arrow,
  },
  computed: {
    validData() {
      return (
        this.form.name &&
        this.form.position &&
        this.form.company &&
        this.form.description &&
        this.form.cv_url &&
        this.form.linkedin_url &&
        (this.isEdit || this.img_web)
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      img_web: null,
      form: {
        name: "",
        image_url: "",
        position: "",
        company: "",
        description: "",
        cv_url: "",
        linkedin_url: "",
      },
      formEng: {
        name: "",
        position: "",
        company: "",
        description: "",
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataInstructor();
    },
    async getDataInstructor() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/instructor/" + this.id);
        this.form = resp.data.data.instructor;
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=instructor&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          name: resp.name || "",
          position: resp.position || "",
          company: resp.company || "",
          description: resp.description || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let imageUrl = this.form.image_url;

        if (this.img_web) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.img_web);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          imageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        const payload = {
          name: this.form.name,
          image_url: imageUrl,
          position: this.form.position,
          company: this.form.company,
          description: this.form.description,
          cv_url: this.form.cv_url,
          linkedin_url: this.form.linkedin_url,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/instructor/" + this.form.id, payload);
          await this.onSubmitBilingual(imageUrl);
        } else {
          await this.$crm_http.post("/v1/instructor", payload);
          const redirect = sessionStorage.getItem("redirect");
          if (redirect) {
            this.$router.push(redirect);
          }
        }

        setTimeout(() => {
          this.$router.push("/instructor");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(imageUrl) {
      const payload = {
        table_name: "instructor",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          name: this.formEng.name,
          position: this.formEng.position,
          company: this.formEng.company,
          description: this.formEng.description,
          image_url: imageUrl,
          cv_url: this.form.cv_url,
          linkedin_url: this.form.linkedin_url,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>